import { render, staticRenderFns } from "./ShieldFooter.vue?vue&type=template&id=1485a6d0&scoped=true&"
import script from "./ShieldFooter.vue?vue&type=script&lang=js&"
export * from "./ShieldFooter.vue?vue&type=script&lang=js&"
import style0 from "./ShieldFooter.vue?vue&type=style&index=0&id=1485a6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485a6d0",
  null
  
)

export default component.exports